import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Stack,
    Typography,
    Paper,
    Button,
    IconButton,
    Divider,
    Modal
} from "@mui/material";
import { isMobile } from "react-device-detect";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import GbaLogo from "../../assets/traffic_monster/GBA_Logo.png";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { toast } from "react-toastify";
import ContactUsModal from "components/ContactUsModal";
import { useGetUserDetailsMutation } from "redux/api/authApi";
import { getCookie } from "utils/storageUtils";

const GBARegistrationSuccess = (props: any) => {
    const signupLink = `${process.env.REACT_APP_RETURN_DOMAIN_NAME || "https://ocesha.ai"}/partner/${props.partnerName}`;

    const landingPage =
        `${process.env.REACT_APP_RETURN_DOMAIN_NAME || "https://ocesha.ai"}/gba/welcome`;

    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [helperPopup, setHelperPopup] = useState<boolean>(false);

    const [userDets, setUserDets] = useState<any>();
    const [contactUsOpen, setContactUsOpen] = useState(false);
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const useremail = localStorage.getItem("user_email") || "";


    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({
                email: useremail || getCookie("user_email") || "",
                filter: "",
                start_date: "",
                end_date: "",
            });
            if ("data" in response) {
                setUserDets(response.data.data);
                console.log(response.data.data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleCopySignupLink = async () => {
        try {
            await navigator.clipboard.writeText(signupLink);
            toast.success("Signup link copied!");
        } catch (err) {
            console.error("Failed to copy link:", err);

            // Optional fallback
            const textArea = document.createElement("textarea");
            textArea.value = signupLink;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);

            toast.success("Signup link copied!");
        }
    };

    return (
        <>
            <Box
                sx={{
                    minHeight: "100vh",
                    /* background:
                        "radial-gradient(circle at top,#18243F 0%,#101827 45%,#08111F 100%)", */
                    /* py: 5,
                    px: {
                        xs: 2,
                        md: 5,
                    }, */
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        maxWidth: 1200,
                        mx: "auto",
                        borderRadius: "22px",
                        p: {
                            xs: 3,
                            md: 5,
                        },
                        background:
                            "linear-gradient(180deg,#111C2F 0%,#0D1727 100%)",
                        border: "1px solid rgba(255,255,255,.08)",
                    }}
                >
                    {/* HEADER */}

                    <Grid
                        container
                        spacing={4}
                        alignItems="center"
                        mb={5}
                    >
                        <Grid item xs={12} md={8}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box
                                    sx={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: "50%",
                                        background: "#2DBE60",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <CheckIcon
                                        sx={{
                                            color: "#fff",
                                            fontSize: 28,
                                        }}
                                    />
                                </Box>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: {
                                            xs: "34px",
                                            md: "52px",
                                        },
                                        lineHeight: 1,
                                        letterSpacing: "-0.02em",
                                    }}
                                >
                                    Congratulations!
                                </Typography>
                            </Stack>

                            {/* Row 2 & 3 */}
                            <Box sx={{ ml: { xs: "60px", md: "60px" }, mt: 1 }}>
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 400,
                                        fontSize: {
                                            xs: "20px",
                                            md: "28px",
                                        },
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Your Member Benefit Program is Live
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#A2AEC4",
                                        mt: 2,
                                        fontSize: "16px",
                                        lineHeight: 1.6,
                                    }}
                                >
                                    Government Blockchain Association has been successfully configured.
                                </Typography>
                            </Box>
                        </Grid>

                        {/* GBA Logo */}

                        {props.logoPrev && (<Grid item xs={12} md={4}>
                            <img
                                src={props.logoPrev}
                                alt="GBA"
                                style={{
                                    width: "100%",
                                    maxWidth: 280,
                                    objectFit: "contain",
                                    height: '100px'
                                }}
                            />
                        </Grid>)}
                    </Grid>

                    {/* Link Cards */}

                    <Grid container spacing={3} mb={5}>
                        {/* Member Sign-Up Link */}

                        <Grid item xs={12} md={12}>
                            <Paper
                                elevation={0}
                                sx={{
                                    height: "100%",
                                    borderRadius: "16px",
                                    p: 3,
                                    background: "#111E31",
                                    border: "1px solid rgba(255,255,255,.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: 22,
                                        fontWeight: 400,
                                        mb: 1,
                                    }}
                                >
                                    Member Sign-Up Link
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#9AA6BE",
                                        lineHeight: 1.8,
                                        mb: 3,
                                    }}
                                >
                                    Share this link with your members to activate
                                    their complimentary AI Professional Plan.
                                </Typography>

                                <Stack
                                    direction={{
                                        xs: "column",
                                        sm: "row",
                                    }}
                                    spacing={2}
                                >
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            flex: 1,
                                            px: 2,
                                            py: 1.8,
                                            background: "#0E1626",
                                            borderRadius: "12px",
                                            border:
                                                "1px solid rgba(255,255,255,.08)",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#40A6FF",
                                                fontWeight: 500,
                                                wordBreak: "break-all",
                                            }}
                                        >
                                            {signupLink}
                                        </Typography>
                                    </Paper>

                                    <Button
                                        startIcon={<ContentCopyRoundedIcon />}
                                        onClick={handleCopySignupLink}
                                        sx={{
                                            px: 3,
                                            borderRadius: "12px",
                                            textTransform: "none",
                                            color: "#fff",
                                            background:
                                                "linear-gradient(90deg,#5D58FF,#7D4BFF)",

                                            "&:hover": {
                                                background:
                                                    "linear-gradient(90deg,#5D58FF,#7D4BFF)",
                                            },
                                        }}
                                    >
                                        Copy Link
                                    </Button>
                                </Stack>

                                <Paper
                                    elevation={0}
                                    sx={{
                                        mt: 3,
                                        p: 2,
                                        background: "#0E1626",
                                        borderRadius: "12px",
                                        border:
                                            "1px solid rgba(255,255,255,.08)",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1.5}
                                        alignItems="center"
                                    >
                                        <InfoOutlinedIcon
                                            sx={{
                                                color: "#3EA8FF",
                                                fontSize: 22,
                                                flexShrink: 0,
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#B7C2D6",
                                                lineHeight: 1.8,
                                            }}
                                        >
                                            Members who sign up using this link will automatically be
                                            associated with Government Blockchain Association.
                                        </Typography>
                                    </Stack>
                                </Paper>
                            </Paper>
                        </Grid>

                        {/* Landing Page */}

                        {/* <Grid item xs={12} md={6}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: "100%",
                                borderRadius: "16px",
                                p: 3,
                                background: "#111E31",
                                border: "1px solid rgba(255,255,255,.08)",
                            }}
                        >
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={1}
                            >
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 400,
                                        fontSize: 22,
                                    }}
                                >
                                    Optional: Member Landing Page
                                </Typography>

                                <Box
                                    sx={{
                                        px: 1.5,
                                        py: .4,
                                        borderRadius: "20px",
                                        border: "1px solid #2F8DFF",
                                        color: "#5AAEFF",
                                        fontSize: 12,
                                    }}
                                >
                                    Optional
                                </Box>
                            </Stack>

                            <Typography
                                sx={{
                                    color: "#9AA6BE",
                                    lineHeight: 1.8,
                                    mb: 3,
                                }}
                            >
                                We've created a standard landing page
                                you can use to introduce this benefit
                                to your members.
                            </Typography>

                            <Stack
                                direction={{
                                    xs: "column",
                                    sm: "row",
                                }}
                                spacing={2}
                            >
                                <Paper
                                    elevation={0}
                                    sx={{
                                        flex: 1,
                                        px: 2,
                                        py: 1.8,
                                        background: "#0E1626",
                                        borderRadius: "12px",
                                        border:
                                            "1px solid rgba(255,255,255,.08)",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#40A6FF",
                                            fontWeight: 500,
                                            wordBreak: "break-all",
                                        }}
                                    >
                                        {landingPage}
                                    </Typography>
                                </Paper>

                                <Button
                                    startIcon={<LaunchRoundedIcon />}
                                    onClick={() => window.open(landingPage, "_blank", "noopener,noreferrer")}
                                    variant="outlined"
                                    sx={{
                                        borderRadius: "12px",
                                        textTransform: "none",
                                        color: "#6BB3FF",
                                        borderColor: "#2C6FBF",

                                        "&:hover": {
                                            borderColor: "#2C6FBF",
                                        },
                                    }}
                                >
                                    Preview Page
                                </Button>
                            </Stack>

                            <Typography
                                sx={{
                                    mt: 3,
                                    color: "#9AA6BE",
                                    lineHeight: 1.8,
                                }}
                            >
                                You can also use your own landing page
                                and link directly to the sign-up URL
                                above.
                            </Typography>
                        </Paper>
                    </Grid> */}
                    </Grid>

                    {/* Member Benefits */}

                    <Paper
                        elevation={0}
                        sx={{
                            mb: 5,
                            p: 3,
                            borderRadius: "16px",
                            background: "#111E31",
                            border: "1px solid rgba(255,255,255,.08)",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 400,
                                fontSize: 24,
                                mb: 4,
                            }}
                        >
                            Member Benefits (Included for All Members)
                        </Typography>

                        <Grid container>
                            {[
                                {
                                    title: "Branded AI\nAuthority Page",
                                    desc:
                                        "Professional, AI-optimized authority page for every member.",
                                    icon: <BadgeOutlinedIcon />,
                                    color: "#8B5CF6",
                                },
                                {
                                    title: "GBA Expert\nDirectory",
                                    desc:
                                        "Be discoverable in the AI-powered GBA Expert Directory.",
                                    icon: <PeopleAltOutlinedIcon />,
                                    color: "#8B5CF6",
                                    link: `${process.env.REACT_APP_RETURN_DOMAIN_NAME}/codegenie/creator-directory/GBA`,
                                },
                                {
                                    title: "GBA Course\nDirectory",
                                    desc:
                                        "Create and share one complimentary professional course.",
                                    icon: <SchoolOutlinedIcon />,
                                    color: "#8B5CF6",
                                    link: `${process.env.REACT_APP_RETURN_DOMAIN_NAME}/codegenie/courses-directory/GBA`,
                                },
                                {
                                    title: "AI Search &\nDiscoverability",
                                    desc:
                                        "Increase your visibility across Google and AI search platforms.",
                                    icon: <SearchOutlinedIcon />,
                                    color: "#3B82F6",
                                },
                                {
                                    title:
                                        "Complimentary AI Professional Plan\nfor Members",
                                    desc:
                                        "Full access to the AI Professional Plan at no cost.",
                                    icon: <CardGiftcardOutlinedIcon />,
                                    color: "#22C55E",
                                },
                            ].map((item, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={2.4 as any}
                                    key={index}
                                >
                                    <Box
                                        sx={{
                                            height: "100%",
                                            px: 3,
                                            py: 2,
                                            textAlign: "center",
                                            borderRight:
                                                index !== 4
                                                    ? "1px solid rgba(255,255,255,.08)"
                                                    : "none",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                mb: 2,
                                            }}
                                        >
                                            {React.cloneElement(item.icon, {
                                                sx: {
                                                    fontSize: 42,
                                                    color: item.color,
                                                },
                                            })}
                                        </Box>

                                        <Typography
                                            onClick={() => {
                                                if (item.link) {
                                                    window.open(item.link, "_blank");
                                                }
                                            }}
                                            sx={{
                                                color: item.link ? "#8B5CF6" : "#fff",
                                                fontWeight: 400,
                                                fontSize: 18,
                                                whiteSpace: "pre-line",
                                                minHeight: 60,
                                                cursor: item.link ? "pointer" : "default",
                                                textDecoration: item.link ? "underline" : "none",
                                                transition: "0.2s",

                                                "&:hover": item.link
                                                    ? {
                                                        color: "#A78BFA",
                                                    }
                                                    : {},
                                            }}
                                        >
                                            {item.title}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#9AA6BE",
                                                mt: 2,
                                                lineHeight: 1.8,
                                                fontSize: 14,
                                            }}
                                        >
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Paper>

                    {/* Download Launch Kit */}

                    <Paper
                        elevation={0}
                        sx={{
                            mb: 5,
                            p: 3,
                            borderRadius: "16px",
                            background: "#111E31",
                            border: "1px solid rgba(255,255,255,.08)",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 400,
                                fontSize: 24,
                                mb: 1,
                            }}
                        >
                            Download Your Launch Kit
                        </Typography>

                        <Typography
                            sx={{
                                color: "#9AA6BE",
                                mb: 4,
                            }}
                        >
                            Everything you need to announce and launch your new member
                            benefit.
                        </Typography>

                        <Grid container spacing={2}>
                            {[
                                {
                                    icon: <EmailOutlinedIcon />,
                                    color: "#3B82F6",
                                    title: "Newsletter\nAnnouncement",
                                },
                                {
                                    icon: <EmailOutlinedIcon />,
                                    color: "#22C55E",
                                    title: "Member Email\nTemplate",
                                },
                                {
                                    icon: <LanguageOutlinedIcon />,
                                    color: "#8B5CF6",
                                    title: "Website\nButton",
                                },
                                {
                                    icon: <ShareOutlinedIcon />,
                                    color: "#EC4899",
                                    title: "Social Media\nPost",
                                },
                                {
                                    icon: <PictureAsPdfOutlinedIcon />,
                                    color: "#EF4444",
                                    title: "One-Page\nPDF",
                                },
                            ].map((item, index) => (
                                <Grid
                                    item
                                    xs={6}
                                    sm={4}
                                    md={2.4 as any}
                                    key={index}
                                >
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            height: 150,
                                            borderRadius: "14px",
                                            background: "#0F192B",
                                            border: "1px solid rgba(255,255,255,.08)",
                                            cursor: "pointer",
                                            transition: ".25s",

                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",

                                            "&:hover": {
                                                transform: "translateY(-4px)",
                                                borderColor: "#5D58FF",
                                            },
                                        }}
                                    >
                                        <Stack spacing={2} alignItems="center">
                                            {React.cloneElement(item.icon, {
                                                sx: {
                                                    fontSize: 38,
                                                    color: item.color,
                                                },
                                            })}

                                            <Typography
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 500,
                                                    whiteSpace: "pre-line",
                                                    fontSize: 15,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                        </Stack>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>

                        <Stack
                            alignItems="center"
                            mt={5}
                        >
                            <Button
                                startIcon={<DownloadRoundedIcon />}
                                onClick={() => {
                                    const link = document.createElement("a");
                                    link.href = "https://app.ocesha.ai/uploads/images/Launch_Kit/Launch_Kit.zip";
                                    link.download = "Launch_Kit.zip";
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                                sx={{
                                    minWidth: 300,
                                    height: 54,
                                    borderRadius: "12px",
                                    textTransform: "none",
                                    color: "#fff",
                                    fontWeight: 600,
                                    fontSize: 16,

                                    background:
                                        "linear-gradient(90deg,#615CFF,#7C4DFF)",

                                    "&:hover": {
                                        background:
                                            "linear-gradient(90deg,#615CFF,#7C4DFF)",
                                    },
                                }}
                            >
                                Download Launch Kit (ZIP)
                            </Button>
                        </Stack>
                    </Paper>

                    {/* Need Help Section */}

                    <Paper
                        elevation={0}
                        sx={{
                            mt: 4,
                            p: 2.5,
                            borderRadius: "14px",
                            background: "#101C30",
                            border: "1px solid rgba(255,255,255,.08)",
                        }}
                    >
                        <Stack
                            direction={{ xs: "column", lg: "row" }}
                            spacing={3}
                            justifyContent="space-between"
                            alignItems={{ xs: "flex-start", lg: "center" }}
                        >
                            {/* Left Section */}
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                            >
                                <Box
                                    sx={{
                                        width: 54,
                                        height: 54,
                                        borderRadius: "50%",
                                        background:
                                            "radial-gradient(circle at 30% 30%, #3B377D 0%, #2D2A63 65%, #252155 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <HeadsetMicOutlinedIcon
                                        sx={{
                                            color: "#fff",
                                            fontSize: 30,
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography
                                        sx={{
                                            color: "#fff",
                                            fontWeight: 400,
                                            fontSize: 28,
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        Need help launching?
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#A4AFC5",
                                            fontSize: 16,
                                            mt: .5,
                                        }}
                                    >
                                        Our team is here to help you every step of the way.
                                    </Typography>
                                </Box>
                            </Stack>

                            {/* Right Section */}

                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={1.5}
                                width={{ xs: "100%", lg: "auto" }}
                            >
                                {[
                                    {
                                        icon: <CalendarTodayOutlinedIcon />,
                                        text: "Schedule a Call",
                                    },
                                    {
                                        icon: <PlayCircleOutlineRoundedIcon />,
                                        text: "Watch a Quick Video",
                                        onClick: () => {
                                            setHelperVideoSrc("https://www.youtube.com/embed/1D80JhbO-UM");
                                            setHelperPopup(true);
                                        },
                                    },
                                    {
                                        icon: <ChatBubbleOutlineRoundedIcon />,
                                        text: "Contact Support",
                                        onClick: () => {
                                            setContactUsOpen(true)
                                        }
                                    },
                                ].map((item) => (
                                    <Button
                                        key={item.text}
                                        startIcon={item.icon}
                                        variant="outlined"
                                        onClick={item.onClick}
                                        sx={{
                                            minWidth: 170,
                                            height: 42,
                                            borderRadius: "10px",
                                            borderColor: "#2D4568",
                                            color: "#D7E2F2",
                                            textTransform: "none",
                                            background: "transparent",

                                            "& .MuiSvgIcon-root": {
                                                color: "#3B9DFF",
                                                fontSize: 20,
                                            },

                                            "&:hover": {
                                                borderColor: "#4A6EA5",
                                                background: "rgba(255,255,255,.03)",
                                            },
                                        }}
                                    >
                                        {item.text}
                                    </Button>
                                ))}
                            </Stack>
                        </Stack>
                    </Paper>
                </Paper>
            </Box>


            {/* Modal Popups */}
            <Modal
                open={helperPopup}
                /* onClose={(event, reason) => {
                            if (reason !== "backdropClick") {
                                setHelperModal(false);
                            }
                        }} */
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "70%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: "15px",
                        padding: "3%",
                    }}
                >
                    {/* <video
                        controls
                        style={{ width: '100%' }}
                        src={helpervideosrc}
                        autoPlay
                    /> */}
                    <iframe
                        width="100%"
                        height="500"
                        src={helpervideosrc}
                        title="Help Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                    <Stack flexDirection="row">
                        <Button
                            onClick={() => setHelperPopup(false)}
                            variant="contained"
                            sx={{ mr: 2, marginTop: "15%" }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <ContactUsModal
                open={contactUsOpen}
                onClose={() => setContactUsOpen(false)}
                userDets={userDets}
            />
            {/* end modals */}
        </>
    );
};

export default GBARegistrationSuccess;